var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEngagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 18.3332H5.49235C4.20453 18.3332 3.18022 17.7065 2.26051 16.8303C0.377763 15.0366 3.46896 13.6032 4.64794 12.9012C6.27544 11.9321 8.16054 11.5335 9.99996 11.7053",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 5.4165C12.9166 7.48757 11.2377 9.1665 9.16663 9.1665C7.09556 9.1665 5.41663 7.48757 5.41663 5.4165C5.41663 3.34544 7.09556 1.6665 9.16663 1.6665C11.2377 1.6665 12.9166 3.34544 12.9166 5.4165Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5124 12.8222C13.4063 12.2891 14.1865 12.5039 14.6552 12.8461C14.8473 12.9864 14.9434 13.0566 15 13.0566C15.0565 13.0566 15.1526 12.9864 15.3447 12.8461C15.8134 12.5039 16.5936 12.2891 17.4875 12.8222C18.6606 13.5218 18.9261 15.8298 16.2201 17.777C15.7047 18.1479 15.447 18.3333 15 18.3333C14.5529 18.3333 14.2952 18.1479 13.7798 17.777C11.0739 15.8298 11.3393 13.5218 12.5124 12.8222Z",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEngagement);
export default __webpack_public_path__ + "static/media/icon-engagement.b4e86e6c155bd499a1338591e189d449.svg";
export { ForwardRef as ReactComponent };